const textExtracer = (data, address) => {
  if (data) {
    if (typeof data === "string") {
      return data;
    } else if (typeof data === "object" && data?.id === null) {
      return "";
    } else {
      const dataIsNested = address?.includes(".");
      if (dataIsNested) {
        const allKeys = address.split(".");
        let properTxt = data;

        for (let i = 0; i < allKeys.length; i++) {
          const currentKey = allKeys[i];

          if (i === allKeys.length - 1) {
            if (Array.isArray(properTxt)) {
              const extractedValues = properTxt.map((item) => item[allKeys[allKeys.length - 1]]);
              return extractedValues.join(",");
            } else if (typeof properTxt[allKeys[allKeys.length - 1]] === "string") {
              return properTxt[allKeys[allKeys.length - 1]];
            } else {
              return "we reached an object at last";
              //check this later
            }
          } else {
            if (Array.isArray(properTxt)) {
              const extractedValues = properTxt.map((item) =>
                textExtracer(item[currentKey], allKeys.slice(i + 1).join(".")),
              );
              return extractedValues.join(",");
            } else if (properTxt && typeof properTxt === "object" && currentKey in properTxt) {
              properTxt = properTxt[currentKey];
            } else {
              return "wrong Address , key does'nt exist";
            }
          }
        }
      } else {
        let properAddress = address
          ? address
          : "name" in data
            ? "name"
            : "title" in data
              ? "title"
              : "code" in data
                ? "code"
                : "id";
        return data[properAddress] ? data[properAddress] : "";
      }
    }
  } else return "";
};

export default textExtracer;
